import { inject } from "vue";
import type { InjectionKey } from "vue";

export function sleep(msec: number) {
  return new Promise((resolve) => window.setTimeout(resolve, msec));
}

export function injectOrThrow<T>(key: InjectionKey<T>, fallback?: T): T {
  const resolved = inject(key, fallback);
  if (!resolved) {
    throw new Error(`${key.description} is not provided`);
  }
  return resolved;
}

export function getOverflowYStyleElement(target: HTMLElement): Element | null {
  let result: Element | null = null;
  let parent = target.parentNode;
  for (let i = 0; parent; i++) {
    if (parent instanceof Element) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.getPropertyValue("overflow-y");

      if (overflowY === "scroll" || overflowY === "auto") {
        result = parent;
        break;
      }
    }
    parent = parent.parentNode;
  }

  return result;
}
